/* 🤖 this file was generated by svg-to-ts*/
export const icoZoomOutFilled: {
  name: 'zoom-out-filled';
  data: string;
} = {
  name: 'zoom-out-filled',
  data: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11 3a8 8 0 016.32 12.905l3.387 3.388a1 1 0 01-1.32 1.497l-.094-.083-3.388-3.386A8 8 0 1111 3zm3 7H8l-.117.007A1 1 0 008 12h6l.117-.007A1 1 0 0014 10z" fill="#909090"/></svg>`
};
